// Resources
import API from "../helpers/API"

/**
 * Componente funcional para manipulacão dos dados do pixel
 */
const PixelController = {
  getPixelId() {
    return API.request("/v1/integration/pixel/id", {}, "GET")
  },

  // InitiateCheckout via Conversion API (server-side). Mesmo event_id do browser pra dedup.
  sendInitiateCheckout(payload) {
    return API.request("/v1/integration/pixel/initiate-checkout", payload, "POST")
  },
}

export default PixelController
